(function () {
  'use strict';

  var CONFIG = window.AldrenRoweGift || {};
  var GIFT_HANDLE = CONFIG.handle || 'cedar-shoe-tree';
  var GIFT_TITLE_MATCH = 'cedar shoe tree';
  var giftId = CONFIG.variantId ? Number(CONFIG.variantId) : null;
  var giftResolvePromise = null;
  var giftMutationLock = false;
  var drawerRefreshSeq = 0;

  function root() {
    var value = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return /\/$/.test(value) ? value : value + '/';
  }

  function route(path) {
    return root() + String(path || '').replace(/^\//, '');
  }

  function lower(value) {
    return String(value || '').toLowerCase();
  }

  function isGiftItem(item) {
    if (!item) return false;
    if (giftId && Number(item.variant_id) === Number(giftId)) return true;
    if (item.properties) {
      if (String(item.properties._aldren_rowe_gift || '') === 'true') return true;
      // Backwards compatibility with carts created by an older version of the theme.
      if (String(item.properties._aveltero_gift || '') === 'true') return true;
    }
    return lower(item.product_title || item.title).indexOf(GIFT_TITLE_MATCH) !== -1;
  }

  function footwearQuantity(cart) {
    var quantity = 0;
    (cart.items || []).forEach(function (item) {
      if (!isGiftItem(item)) quantity += Number(item.quantity || 0);
    });
    return quantity;
  }

  function giftLine(cart) {
    return (cart.items || []).filter(isGiftItem)[0] || null;
  }

  function money(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    var symbol = currency === 'EUR' ? '€' : currency === 'GBP' ? '£' : '$';
    return symbol + (Number(cents || 0) / 100).toFixed(2);
  }

  function paint(cart) {
    var qty = footwearQuantity(cart);
    var box = document.getElementById('ssco');

    if (box) {
      var fill = document.getElementById('sscoFill');
      var msg = document.getElementById('sscoMsg');
      var pct = qty >= 4 ? 100 : qty >= 3 ? 66 : qty >= 2 ? 33 : qty >= 1 ? 16 : 0;

      if (fill) fill.style.width = pct + '%';

      box.querySelectorAll('.ssco-step').forEach(function (step) {
        step.classList.toggle('on', qty >= parseInt(step.getAttribute('data-step'), 10));
      });

      if (msg) {
        if (qty >= 4) msg.innerHTML = 'Maximum saving unlocked: <b>extra 20% off</b>';
        else if (qty === 3) msg.innerHTML = '<b>Extra 15% off</b> unlocked. Add 1 more pair for <b>extra 20%</b>';
        else if (qty === 2) msg.innerHTML = '<b>Extra 10% off</b> unlocked. Add 1 more pair for <b>extra 15%</b>';
        else if (qty === 1) msg.innerHTML = 'Add 1 more pair to unlock <b>an extra 10% off</b>';
        else msg.innerHTML = 'Add 2 pairs to unlock <b>an extra 10% off</b>';
      }
    }

    var saving = document.getElementById('sscoSav');
    if (saving) {
      var discount = Number(cart.total_discount || 0);
      var value = saving.querySelector('.ssco-sav-val');
      if (discount > 0) {
        if (value) value.textContent = '-' + money(discount);
        saving.style.display = 'flex';
      } else {
        saving.style.display = 'none';
      }
    }
  }

  function fetchCart() {
    return fetch(route('cart.js'), {
      cache: 'no-store',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('cart fetch failed');
      return response.json();
    });
  }

  function resolveGiftId(cart) {
    var existing = giftLine(cart || { items: [] });
    if (existing && existing.variant_id) {
      giftId = Number(existing.variant_id);
      return Promise.resolve(giftId);
    }

    // Preferred path: Liquid resolves the product variant on the server.
    if (giftId) return Promise.resolve(giftId);
    if (giftResolvePromise) return giftResolvePromise;

    function fromProductJson(url) {
      return fetch(url, { cache: 'no-store', credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('gift product not found');
          return response.json();
        })
        .then(function (product) {
          var variants = (product && product.variants) || [];
          var variant = variants.find(function (item) {
            return item && item.available !== false;
          }) || variants[0];

          if (!variant || !variant.id) throw new Error('gift variant not found');
          giftId = Number(variant.id);
          return giftId;
        });
    }

    giftResolvePromise = fromProductJson(route('products/' + GIFT_HANDLE + '.js'))
      .catch(function () {
        return fetch(
          route('search/suggest.json') +
            '?q=' + encodeURIComponent('Cedar Shoe Tree') +
            '&resources[type]=product&resources[limit]=10',
          { cache: 'no-store', credentials: 'same-origin' }
        )
          .then(function (response) {
            if (!response.ok) throw new Error('gift search failed');
            return response.json();
          })
          .then(function (data) {
            var products =
              (data && data.resources && data.resources.results && data.resources.results.products) || [];
            var match = products.find(function (product) {
              return lower(product.title).indexOf(GIFT_TITLE_MATCH) !== -1;
            });
            if (!match || !match.handle) throw new Error('gift product unavailable');
            return fromProductJson(route('products/' + match.handle + '.js'));
          });
      })
      .catch(function (error) {
        if (window.console && console.warn) {
          console.warn('[Aldren & Rowe] Cedar Shoe Tree gift could not be resolved:', error);
        }
        return null;
      })
      .then(function (id) {
        giftResolvePromise = null;
        return id;
      });

    return giftResolvePromise;
  }

  function changeGift(id, quantity) {
    return fetch(route('cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(id), quantity: quantity })
    }).then(function (response) {
      if (!response.ok) throw new Error('gift quantity change failed');
      return response.json();
    });
  }

  function addGift(id) {
    return fetch(route('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: Number(id),
            quantity: 1,
            properties: { _aldren_rowe_gift: 'true' }
          }
        ]
      })
    }).then(function (response) {
      if (!response.ok) {
        return response.text().then(function (text) {
          throw new Error('gift add failed: ' + text);
        });
      }
      return response.json();
    });
  }

  function refreshDrawer() {
    var sequence = ++drawerRefreshSeq;
    var separator = window.location.search ? '&' : '?';
    var url = window.location.pathname + window.location.search + separator + 'sections=cart-drawer-section';

    return fetch(url, { cache: 'no-store', credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('cart drawer refresh failed');
        return response.json();
      })
      .then(function (data) {
        if (sequence !== drawerRefreshSeq) return;
        var html = data && data['cart-drawer-section'];
        if (!html) return;

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector('cart-drawer-component');
        var current = document.querySelector('cart-drawer-component');
        if (incoming && current) current.innerHTML = incoming.innerHTML;
      })
      .catch(function (error) {
        if (window.console && console.warn) {
          console.warn('[Aldren & Rowe] Cart drawer refresh failed:', error);
        }
      });
  }

  function dispatchCartRefresh(cart, action) {
    try {
      var event = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
      event.action = action || 'update';
      event.context = 'cart';
      event.lines = [];
      event.__aldrenRoweGift = true;
      event.promise = Promise.resolve({
        cart: {
          id: cart.token || '',
          totalQuantity: Number(cart.item_count || 0),
          cost: { totalAmount: { amount: String((Number(cart.total_price || 0) / 100).toFixed(2)), currencyCode: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP' } },
          lines: [],
          discountCodes: []
        },
        detail: {
          items: cart.items || [],
          itemCount: Number(cart.item_count || 0),
          source: 'aldren-rowe-gift',
          didError: false
        }
      });
      document.dispatchEvent(event);
    } catch (error) {
      // Cart drawer refresh still keeps the customer-facing cart accurate.
    }
  }

  function finishMutation(action) {
    return fetchCart()
      .then(function (cart) {
        paint(cart);
        dispatchCartRefresh(cart, action);
        return refreshDrawer().then(function () {
          paint(cart);
          return cart;
        });
      })
      .finally(function () {
        giftMutationLock = false;
      });
  }

  // Called only after an actual customer cart action. It never runs an add-to-cart
  // mutation simply because the page was opened.
  function handleCustomerCartAction(action) {
    if (giftMutationLock) return;

    fetchCart()
      .then(function (cart) {
        paint(cart);

        var qty = footwearQuantity(cart);
        var gift = giftLine(cart);

        // Add the complimentary shoe trees only after the customer explicitly adds
        // footwear. Opening or refreshing the site never adds a product to the cart.
        if (action === 'add' && qty > 0 && !gift) {
          return resolveGiftId(cart).then(function (id) {
            if (!id || giftMutationLock) return;
            giftMutationLock = true;
            return addGift(id)
              .then(function () { return finishMutation('update'); })
              .catch(function (error) {
                giftMutationLock = false;
                if (window.console && console.warn) console.warn('[Aldren & Rowe] Gift add failed:', error);
              });
          });
        }

        // If all paid footwear is removed, clean up an orphaned complimentary gift.
        // If the customer removes the gift while keeping their shoes, we respect that
        // choice and DO NOT add it back automatically.
        if (qty < 1 && gift) {
          giftMutationLock = true;
          return changeGift(gift.key || gift.variant_id, 0)
            .then(function () { return finishMutation('update'); })
            .catch(function (error) {
              giftMutationLock = false;
              if (window.console && console.warn) console.warn('[Aldren & Rowe] Gift cleanup failed:', error);
            });
        }
      })
      .catch(function (error) {
        if (window.console && console.warn) console.warn('[Aldren & Rowe] Cart read failed:', error);
      });
  }

  function initialPaintOnly() {
    // Important: opening or refreshing the site never adds a paid product or gift.
    // We only remove an orphaned free gift if no paid footwear remains in the cart.
    fetchCart()
      .then(function (cart) {
        paint(cart);
        var gift = giftLine(cart);
        if (footwearQuantity(cart) < 1 && gift && !giftMutationLock) {
          giftMutationLock = true;
          return changeGift(gift.key || gift.variant_id, 0)
            .then(function () { return finishMutation('update'); })
            .catch(function (error) {
              giftMutationLock = false;
              if (window.console && console.warn) console.warn('[Aldren & Rowe] Orphan gift cleanup failed:', error);
            });
        }
      })
      .catch(function (error) {
        if (window.console && console.warn) console.warn('[Aldren & Rowe] Initial cart read failed:', error);
      });
  }

  function timer() {
    if (window.__aldrenRoweCartTimer) return;
    var element = document.getElementById('sscoTimer');
    if (!element) return;

    var storageKey = 'aldren_rowe_cart_reservation';
    var end = sessionStorage.getItem(storageKey);
    if (!end || Number(end) < Date.now()) {
      end = Date.now() + 300000;
      sessionStorage.setItem(storageKey, String(end));
    }
    end = Number(end);

    window.__aldrenRoweCartTimer = setInterval(function () {
      var target = document.getElementById('sscoTimer');
      if (!target) return;

      var remaining = Math.max(0, end - Date.now());
      if (remaining === 0) {
        end = Date.now() + 300000;
        sessionStorage.setItem(storageKey, String(end));
        remaining = 300000;
      }

      var minutes = Math.floor(remaining / 60000);
      var seconds = Math.floor((remaining % 60000) / 1000);
      target.textContent =
        (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
    }, 1000);
  }

  document.addEventListener('shopify:cart:lines-update', function (event) {
    if (event.__aldrenRoweGift) return;
    var action = event.action || 'update';

    if (event.promise && typeof event.promise.then === 'function') {
      event.promise
        .then(function () {
          window.setTimeout(function () { handleCustomerCartAction(action); }, 40);
        })
        .catch(function () {});
    } else {
      window.setTimeout(function () { handleCustomerCartAction(action); }, 80);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    timer();
    initialPaintOnly();
  });

  if (document.readyState !== 'loading') {
    timer();
    initialPaintOnly();
  }
})();
